// extracted by mini-css-extract-plugin
export var footer = "layout-module--footer--ad7d0";
export var header = "layout-module--header--4755c";
export var inner = "layout-module--inner--3aa48";
export var navbar = "layout-module--navbar--d1c06";
export var navbarActiveLink = "layout-module--navbarActiveLink--e21ea";
export var navbarLink = "layout-module--navbarLink--ac235";
export var outer = "layout-module--outer--4dfcf";